import { render, staticRenderFns } from "./r-item-upgrade-rule-table.vue?vue&type=template&id=76dd70d9"
import script from "./r-item-upgrade-rule-table.vue?vue&type=script&lang=js"
export * from "./r-item-upgrade-rule-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76dd70d9')) {
      api.createRecord('76dd70d9', component.options)
    } else {
      api.reload('76dd70d9', component.options)
    }
    module.hot.accept("./r-item-upgrade-rule-table.vue?vue&type=template&id=76dd70d9", function () {
      api.rerender('76dd70d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/upgrade/r-item-upgrade-rule-table.vue"
export default component.exports